import { render, staticRenderFns } from "./tree-item.vue?vue&type=template&id=3fb46e6c&scoped=true&"
import script from "./tree-item.vue?vue&type=script&lang=js&"
export * from "./tree-item.vue?vue&type=script&lang=js&"
import style0 from "./tree-item.vue?vue&type=style&index=0&id=3fb46e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb46e6c",
  null
  
)

export default component.exports